import React, { FC, createContext, useContext } from 'react';

interface Features {
    myMediiiaMobileEnabled: boolean;
}

const defaultFeatures: Features = {
    myMediiiaMobileEnabled: true,
};

const FeatureContext = createContext<Features>(defaultFeatures);

export const useFeatureAvailability = () => {
    return useContext(FeatureContext);
};

interface FeatureProviderProps {
    children: React.ReactNode;
}

export const FeatureProvider: FC<FeatureProviderProps> = ({ children }) => {
    const features: Features = {
        myMediiiaMobileEnabled: true,//откл|вкл новое мобильное меню вместо футера на media и конектсах
    };

    return (
        <FeatureContext.Provider value={features}>
            {children}
        </FeatureContext.Provider>
    );
};import React, { FC, createContext, useContext } from 'react';

interface Features {
    myMediiiaMobileEnabled: boolean;
}

const defaultFeatures: Features = {
    myMediiiaMobileEnabled: true,
};

const FeatureContext = createContext<Features>(defaultFeatures);

export const useFeatureAvailability = () => {
    return useContext(FeatureContext);
};

interface FeatureProviderProps {
    children: React.ReactNode;
}

export const FeatureProvider: FC<FeatureProviderProps> = ({ children }) => {
    const features: Features = {
        myMediiiaMobileEnabled: true,//откл|вкл новое мобильное меню вместо футера на media и конектсах
    };

    return (
        <FeatureContext.Provider value={features}>
            {children}
        </FeatureContext.Provider>
    );
};